import { useCallback, useEffect, useRef } from 'preact/hooks';

/**
 * Returns a setTimeout-compatible stable function, which automatically clears
 * the previously scheduled callback every time it's called.
 *
 * The timeout instance is not returned, as the hook internally handles
 * clearing it.
 */
export function useTimeout() {
  var setTimeout_ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : setTimeout;
  var clearTimeout_ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : clearTimeout;
  var timeoutRef = useRef(null);
  var clearCurrentTimeout = useCallback(function () {
    if (timeoutRef.current) {
      clearTimeout_(timeoutRef.current);
    }
  }, [clearTimeout_]);

  // When unmounted, clear the last timeout, if any
  useEffect(function () {
    return clearCurrentTimeout;
  }, [clearCurrentTimeout]);
  return useCallback(function (callback, delay) {
    clearCurrentTimeout();
    timeoutRef.current = setTimeout_(function () {
      callback();
      timeoutRef.current = null;
    }, delay);
  }, [clearCurrentTimeout, setTimeout_]);
}
//# sourceMappingURL=use-timeout.js.map